import Dialog from '../../../components/ReusableComponents/Dialog'
import styles from './RejectDialog.module.scss'
import useRadio from './useRadio'

const GenericDialog = ({
  handleHideDialog,
  handleConfirm,
  buttonText,
  title,
  children
}) => (
  <Dialog>
    <div className={styles.dialog}>
      <div className={styles.header}>
        <h1>{title}</h1>
        <button className={styles.close} onClick={handleHideDialog}></button>
      </div>
      <div className={styles.confirm}>
        {children}
        <button className={styles.button} onClick={handleConfirm}>
          {buttonText}
        </button>
      </div>
    </div>
  </Dialog>
)

// export const RejectDialog = props => {
//   const [reason, setReason] = useRadio()

//   return (
//     <GenericDialog
//       {...props}
//       handleConfirm={() => props.handleConfirm(reason)}
//       title={`Select a reason to remove ${
//         props.multiBookings ? 'these bookings' : 'this booking'
//       }`}
//       buttonText={`Remove ${props.multiBookings ? 'bookings' : 'booking'}`}
//     >
//       <form action="">
//         <Radio id="incompleteAddress" name="rejectReason" onChange={setReason}>
//           Incomplete address
//         </Radio>
//         <Radio id="streetNoMismatch" name="rejectReason" onChange={setReason}>
//           Street number mismatch
//         </Radio>
//         <Radio id="groupBooking" name="rejectReason" onChange={setReason}>
//           Group booking
//         </Radio>
//         <Radio id="corporateBooking" name="rejectReason" onChange={setReason}>
//           Corporate booking
//         </Radio>
//         <Radio id="repeatGuest" name="rejectReason" onChange={setReason}>
//           Repeat Guest
//         </Radio>
//         <Radio id="notEnoughInfo" name="rejectReason" onChange={setReason}>
//           Not enough information
//         </Radio>
//         <Radio id="otaBooking" name="rejectReason" onChange={setReason}>
//           OTA Booking
//         </Radio>
//         <Radio id="longTimeAfterInvite" name="rejectReason" onChange={setReason}>
//           Long time after invite
//         </Radio>
//         <Radio id="hotelFriendsAndFamily" name="rejectReason" onChange={setReason}>
//           Hotel friends &amp; family
//         </Radio>
//       </form>
//     </GenericDialog>
//   )
// }

export const AcceptDialog = props => {
  const [reason, setReason] = useRadio()

  return (
    <GenericDialog
      {...props}
      handleConfirm={() => props.handleConfirm(reason)}
      title={`Select a reason to include ${
        props.multiBookings ? 'these bookings' : 'this booking'
      }`}
      buttonText={`Include ${props.multiBookings ? 'bookings' : 'booking'}`}
    >
      <form action="">
        <Radio id="repeatGuest" name="acceptReason" onChange={setReason}>
          Accepted guest
        </Radio>
        <Radio id="multipleBookings" name="acceptReason" onChange={setReason}>
          Multiple bookings
        </Radio>
        <Radio id="wrongDates" name="acceptReason" onChange={setReason}>
          Wrong dates
        </Radio>
        <Radio id="testBooking" name="acceptReason" onChange={setReason}>
          Test booking
        </Radio>
      </form>
    </GenericDialog>
  )
}

const Radio = ({ id, name, children, onChange }) => (
  <div>
    <input type="radio" id={id} name={name} onChange={onChange} />
    <label htmlFor={id}>{children}</label>
  </div>
)
